import { breakpoints } from '@web-for-marketing/react-ui';
import { typographyStyles } from '@web-for-marketing/react-ui';

export const blogCardStyle = {
    image: {
        width: '100%',
        height: '100%',
        objectFit: 'cover',
        transition: 'transform 0.3s ease-in-out',
    },
    cardContent: {
        padding: '0  1.6rem 1.6rem 1.6rem',
    },
    description: {
        marginBottom: '0.8rem',
    },
    timeBlock: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'flex-start',
        width: '100%',
    },
    readMinutes: {
        display: 'flex',
        alignitems: 'center',
    },
    divider: {
        ...typographyStyles.body2,
        margin: '0 8px',
        [`@media (max-width: ${breakpoints.xs})`]: {
            display: 'none',
        },
    },
} as const;
